<template>
  <v-card class="text-xs-center">
    <setPromotionBannerTable/>
  </v-card>
</template>

<script>
import setPromotionBannerTable from "@/components/back-office/SetApp/Banner/SetPromotionBannerTable";
export default {
  components: {
    setPromotionBannerTable
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/"
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province
      },
      {
        text: "App setting",
        disabled: true
      },
      {
        text: "Set banner",
        disabled: true
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style>
</style>
